import React from 'react';
import { LifeBuoyIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CtaSection() {
  return <section className="w-full bg-white py-16 md:py-24 border-t border-gray-200" data-id="element-107">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-108">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-109">
          {/* Main CTA */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-110">
            <h2 className="text-3xl md:text-4xl font-bold text-[#111111] mb-4" data-id="element-111">
              Ready to build digital confidence for your family?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-112">
              Start with a free Family Safety Checkup. In under 3 minutes,
              you'll get a personalized plan to protect everyone you love.
            </p>
            <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-113">
              Get Started
            </Link>
          </div>

          {/* Crisis CTA */}
          <div className="bg-[#f8f8f8] rounded-2xl p-8 border-2 border-gray-200" data-id="element-114">
            <div className="flex items-center mb-4" data-id="element-115">
              <div className="w-12 h-12 bg-[#631bb7] bg-opacity-5 rounded-xl flex items-center justify-center border border-[#631bb7] border-opacity-10 mr-4" data-id="element-116">
                <LifeBuoyIcon className="w-6 h-6 text-[#631bb7]" data-id="element-117" />
              </div>
              <h3 className="text-2xl font-bold text-[#111111]" data-id="element-118">
                Has Someone You Love Been Victimized?
              </h3>
            </div>
            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-119">
              If you or a loved one has been scammed or hacked, our free Crisis
              Response Guide walks you through exactly what to do — step by step
              — including who to contact first and how to limit the damage.
            </p>
            <Link to="/crisis-help" className="bg-[#631bb7] text-white px-6 py-3 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-120">
              See the Crisis Response Guide →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}